import { orderPageState } from "@/atoms/order/order-page-state";
import { pageNumberState } from "@/atoms/order/page-number-state";
import { AdminOrderExcelDownloadButton } from "@/components/button/AdminOrderExcelDownloadButton";
import { Pagination, Table } from "flowbite-react";
import React from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { OrderSortType } from "@/common/enum/partner-manage-order-sort";

interface Props {
  headersLength: number;
  currentFilters: {
    fromDate?: Date;
    toDate?: Date;
    orderType?: OrderSortType;
    keyword?: string;
  };
}

export const AdminOrderFooter: React.FC<Props> = ({
  headersLength,
  currentFilters,
}) => {
  const [page, setPage] = useRecoilState(orderPageState);

  const handlePageChange = (currentPage: number) => {
    setPage({ ...page, currentPage });
  };

  const setPageNumber = useSetRecoilState(pageNumberState);

  return (
    <Table.Row className="bg-white">
      <Table.Cell colSpan={headersLength}>
        <div className="flex items-center">
          <AdminOrderExcelDownloadButton
            currentFilters={currentFilters}
            className="m-[16px]"
          />

          <Pagination
            className="ml-auto"
            currentPage={page.currentPage}
            totalPages={page.totalPage}
            onPageChange={(currentPage: number) => {
              setPageNumber(currentPage);
            }}
            nextLabel=""
            previousLabel=""
            showIcons
          />
        </div>
      </Table.Cell>
    </Table.Row>
  );
};
